import React from 'react';
import { NewUserInner } from 'shared/account/pages/NewUser/NewUser';
import { Button, Scroller } from './styled';
import { QuickDrawer } from 'shared/components/QuickDrawer';

export const NewUser = React.memo(({
  isNewUserDrawerOpen,
  handleNewUserDrawerClose,
  accountId,
  listUsers,
  onDirty
}) => {
  return (
    <QuickDrawer
      open={isNewUserDrawerOpen}
      title="New User"
      onClose={handleNewUserDrawerClose}
    >
      <Scroller>
        <NewUserInner
          account_id={accountId}
          extraButtons={<Button onClick={handleNewUserDrawerClose}>Cancel</Button>}
          refreshUserList={listUsers}
          handleClose={handleNewUserDrawerClose}
          onDirty={onDirty}
        />
      </Scroller>
    </QuickDrawer>
  );
});
